import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgError = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-error))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <path
        fill="hsl(var(--system-icon-white))"
        d="M32 13.5c10.218 0 18.5 8.285 18.5 18.5S42.218 50.5 32 50.5c-10.216 0-18.5-8.284-18.5-18.5S21.784 13.5 32 13.5"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M49 32c0-9.387-7.61-17-17-17-9.388 0-17 7.613-17 17s7.612 17 17 17c9.39 0 17-7.612 17-17m3 0c0 11.045-8.954 20-20 20s-20-8.955-20-20 8.955-20 20-20 20 8.956 20 20"
      />
      <path
        fill="hsl(var(--system-icon-foreground))"
        d="M32.01 38.092a1.5 1.5 0 1 1 0 3h-.02a1.5 1.5 0 0 1 0-3zm-1.52-4.845v-8.838a1.5 1.5 0 0 1 3 0v8.838a1.5 1.5 0 0 1-3 0"
      />
    </svg>
  );
};
export default SvgError;
